import type { SxProps, Theme } from "@mui/material";

export const paginationSx: SxProps<Theme> = (theme) => ({
  "& .MuiInputBase-root": {
    height: "32px",
    minWidth: "32px",
    width: "fit-content",
    padding: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: theme.palette.text.brand,
  },
  "& .MuiInputBase-input": {
    padding: 0,
    fontWeight: theme.typography.fontWeightMedium,
    textAlign: "center",
    width: "3ch",
    boxSizing: "border-box",
  },
  "& input[type=number]": {
    "MozAppearance": "textfield",
    "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
      WebkitAppearance: "none",
      margin: 0,
    },
  },
});
